import React from 'react';
import Body from './components/Body/Body';
import Header from './components/Header/Header';
import Profile from './containers/Profile';
import PaymentStatus from './components/Payment/PaymentStatus';
import SummaryScreen from './components/Customer/SummaryScreen';
import ErrorBoundary from './components/ErrorBoundary';
import MembershipFeatures from './components/MemberShip/MemberShip';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import GlobalAlert from './components/Alert/GlobalAlert';
import MyPlans from './components/MyPlans/MyPlans';
import RaiseClaim from './components/Claim/RaiseClaim';
import TrackClaim from './components/Claim/TrackClaim';
import './axiosConfig';





function App() {

  return (
    // <ErrorBoundary >
    <BrowserRouter>
    <GlobalAlert />
    {/* <Router> */}
      <Header />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/membership-features" element={<MembershipFeatures />} />
        <Route path="/customer-profile" element={<Profile />} />
        <Route path="/summary" element={<SummaryScreen />} />
        <Route path="/payment-status" element={<PaymentStatus />} />
        <Route path="/summary" element={<SummaryScreen />} />
        <Route path="/my-plans" element={<MyPlans />} />
        <Route path="/raise-claim" element={<RaiseClaim />} />
        <Route path="/track-claim" element={<TrackClaim />} />
      </Routes>
    {/* </Router> */}
    </BrowserRouter>
  //  </ErrorBoundary>
  );
}

export default App;
